export const AXIS = { fontSize: 10, fill: "#9CA3AF" };
export const TOOLTIP_STYLE = { background: "#FFFFFF", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 12 };
export const LABEL_STYLE = { color: "#6B7280", fontSize: 11 };
export const LEGEND_STYLE = { fontSize: 10, color: "#4D4D4D" };
export const CHART_MARGIN = { top: 5, right: 10, left: 0, bottom: 0 };
export const SMALL_CHART_MARGIN = { top: 5, right: 8, left: 0, bottom: 0 };
export const BAR_RADIUS = [4, 4, 0, 0];
